import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NO_AUTH } from 'src/app/core/helpers/no-auth.inteceptor';
import { Environment } from 'src/libs/env/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentDataService {
  constructor(private http: HttpClient, private environment: Environment) { }

  public createCardToken(payload): Observable<any> {
    const publicKey = localStorage.getItem("pagarmePublicKey") || null;
    if (publicKey?.length > 0 && payload?.card?.number?.length > 0) {
      let params = new HttpParams();
      params = params.append("appId", publicKey);
      const context = new HttpContext().set(NO_AUTH, true)

      return this.http.post<any>('https://api.pagar.me/core/v5/tokens', payload, { params, context });
    }
    return of(null);
  }

  public sendPaymentData(paymentData: PaymentDataPayload, postPayment: boolean): Observable<PaymentDataResponse> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const paymentOperatorId = currentUser.userId;
    const paymentOperatorName = currentUser.name;

    const url = `${this.environment.api.socioApiURL}${!postPayment ? '/public' : ''}/api/v1/socio/charger?paymentOperatorId=${paymentOperatorId}&paymentOperatorName=${encodeURIComponent(paymentOperatorName)}`;

    return this.http.post<PaymentDataResponse>(url, paymentData);
  }

    public createPaymentLink(paymentData: PaymentDataPayload): Observable<PaymentDataResponse> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const paymentOperatorId = currentUser.userId;
    const paymentOperatorName = currentUser.name;

    const url = `${this.environment.api.socioApiURL}/api/v1/socio/charger/payment-link?paymentOperatorId=${paymentOperatorId}&paymentOperatorName=${encodeURIComponent(paymentOperatorName)}`;

    return this.http.post<PaymentDataResponse>(url, paymentData);
  }

  public sendRecurrentUpgrade(paymentData: RecurrentUpgradeTO): Observable<RecurrentUpgradeTO> {
    return this.http.post<RecurrentUpgradeTO>(
      `${this.environment.api.socioApiURL}/member-plans/upgrade-plan`,
      paymentData
    );
  }

  public getPaymentOrder(paymentId: string): Observable<PaymentDataResponse> {
    let params = new HttpParams();
    params = params.append('showLoader', 'false');
    return this.http.get<PaymentDataResponse>(
      `${this.environment.api.socioApiURL}/public/api/v1/socio/orders/${paymentId}`,
      { params }
    );
  }

  public cancelOrder(transactionId: string): Observable<void> {
    let params = new HttpParams();
    params = params.append('showLoader', 'false');
    return this.http.patch<void>(
      `${this.environment.api.socioApiURL}/api/v1/socio/charger/cancel-order/${transactionId}`,
      { params }
    );
  }

  public cancelPaymentLink(paymentLinkId: string): Observable<void> {
    let params = new HttpParams();
    params = params.append('showLoader', 'false');
    return this.http.patch<void>(
      `${this.environment.api.socioApiURL}/api/v1/socio/charger/cancel-payment-link/${paymentLinkId}`,
      { params }
    );
  }
}

export interface PaymentDataPayload {
  cardToken?: string;
  cardNumber?: string;
  cardHolderName?: string;
  cardCvv?: string;
  cardExpirationDate?: string;
  installments: number;
  amount?: number;
  planId: string;
  memberId: string;
  paymentMethodId: string;
  planPaymentId: string;
  periodicityId: string;
  operationType: string;
  cpf?: string;
  canUseCard: boolean;
  deviceId?: string;
  discount?: number;
  dependents?: DependentPayload[];
  postSerialNumber?: string;
  jerseySizeId?: string;
  jerseyModelId?: string;
  personalizationName?: string;
  personalizationNumber?: string;
  planDiscountId?: string;
  chargeSubscriptionFee?: boolean;
  dueDay?: number;
}

export interface DependentPayload {
  name: string;
  documentType: number;
  cpf: string;
  gender: string;
  birthDate: string;
  relationshipDegreeId?: string;
  dependentAmount?: number;
  originMemberId?: string;
}

export interface RecurrentUpgradeTO {
  memberId: string;
  planId: string;
  planPaymentId: string;
  methodId: string;
  amount: number;
  recurrence: boolean;
  status?: string;
}

export interface PaymentDataResponse {
  id: string;
  status: string;
  qrCodeData: string;
  qrCodeImageUrl: string;
  expiresIn: number;
  error: string;
  declinedCode: string;
  code: number;
  message: string;
}

export enum OperationType {
  NEW = 0,
  UPGRADE = 1,
  DOWNGRADE = 2,
  NEWLOGGED = 3,
  RENEW = 4,
  EARLY_RENEW = 5,
  UPGRADE_RECURRENCE = 6,
  RECURRENCE = 7,
}